import React, { useState } from 'react';
import Paper from '@material-ui/core/Paper';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TablePagination from '@material-ui/core/TablePagination';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ArrowDownward from '@material-ui/icons/ArrowDownward'
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import Toolbar from '@material-ui/core/Toolbar';
import clsx from 'clsx';
import FilterListIcon from '@material-ui/icons/FilterList';
import { useStyles, useToolbarStyles } from './FiliadoTableStyles';
import Box from '@material-ui/core/Box';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControl from '@material-ui/core/FormControl';
import moment from 'moment';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import { yellow, red } from '@material-ui/core/colors';
import { Values } from '../../../../values/Values';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';


function FiliadoTable(props) {
  const { filiados, deleteFiliado, editFiliado, setFiliados, downloadPDF} = props;
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(100);
  const [refreshState, setRefreshState] = useState(new Date());
  const [sortSelected, setSortSelected] = useState('0');
  const [sortType] = useState([
    {
      label: 'Nome',
      value: '0',
      isChecked: false
    },
    {
      label: 'Email',
      value: '1',
      isChecked: false
    },
    {
      label: 'CPF',
      value: '2',
      isChecked: false
    }
  ]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const EnhancedTableToolbar = props => {
    const classes = useToolbarStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = event => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    function onChangeSortType(event) {
      setSortSelected(event.target.value);
    }

    function onChooseSortMenu() {
      if(sortSelected === '0'){
        filiados.result = filiados.result.sort(function (a, b) {
          if (a.nome > b.nome) {
            return 1;
          }
          if (a.nome < b.nome) {
            return -1;
          }
          return 0;
        });
        setFiliados(filiados);
      }
      else if(sortSelected === '1'){
        filiados.result = filiados.result.sort(function (a, b) {
          if (a.email > b.email) {
            return 1;
          }
          if (a.email < b.email) {
            return -1;
          }
          return 0;
        });
        setFiliados(filiados);
      }
      else{
        filiados.result = filiados.result.sort(function (a, b) {
          if (a.cpfCnpj > b.cpfCnpj) {
            return 1;
          }
          if (a.cpfCnpj < b.cpfCnpj) {
            return -1;
          }
          return 0;
        });
        setFiliados(filiados);
      }
    }

    return (
      <Toolbar
        className={clsx(classes.root)}
      >
        <Typography className={classes.title} variant="h4" id="tableTitle">
          Filiados
        </Typography>

        <Tooltip title="Ordenação">
          <IconButton
            aria-label="filter list"
            onClick={handleClick}
          >
            <FilterListIcon />
          </IconButton>
        </Tooltip>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <FormControl >
            <RadioGroup value={sortSelected} onChange={onChangeSortType}>
              {sortType.map((sort) => {
                return (
                  <MenuItem
                    onClick={onChooseSortMenu}
                    key={sort.value}
                  >
                    <FormControlLabel
                      control={
                        <Radio
                          color="primary" />
                      }
                      label= {sort.label}
                      value={sort.value}

                      labelPlacement="end"
                    />
                  </MenuItem>
                );
              })}
            </RadioGroup>
          </FormControl>

        </Menu>
      </Toolbar>
    );
  };

  function onMouseOveRowTable(event, index) {
    filiados.result[index].on_mouse_over = true;
    setRefreshState(new Date());
  }

  function onMouseLeaveRowTable(event, index) {
    filiados.result[index].on_mouse_over = false;
    setRefreshState(new Date());
  }


  return (
    <Paper className={classes.root}>
      <EnhancedTableToolbar numSelected={0} />
      <TableContainer className={classes.containerTable}>
        <Table
          stickyHeader
          aria-label="sticky table"
        >
          <TableHead>
            <TableRow>
              <TableCell
                key={'label_codigo'}
                align={'left'}
              >
                {'Código'}
              </TableCell>
              <TableCell
                key={'label_nome'}
                align={'left'}
              >
                {'Nome'}
              </TableCell>
              <TableCell
                key={'label_cpf'}
                align={'left'}
              >
                {'CPF'}
              </TableCell>
              <TableCell
                key={'label_cr'}
                align={'left'}
              >
                {'Número CR'}
              </TableCell>
              <TableCell
                key={'label_vencimento_anuidade'}
                align={'left'}
              >
                {'Vencimento da Anuidade'}
              </TableCell>
              <TableCell
                key={'label_status'}
                align={'left'}
              >
                {'Status'}
              </TableCell>
              <TableCell
                key={'label_actions'}
                align={'right'}
                style={{width: '12%'}}
              >
                {''}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filiados.result.map((filiado, index) => {
              return (
                <TableRow
                  hover
                  role="checkbox"
                  tabIndex={-1}
                  key={filiado.idFiliado}
                >
                  <TableCell
                    align={'left'}
                  >
                    {filiado.codigo}
                  </TableCell>
                  <TableCell
                    align={'left'}
                  >
                    {filiado.nome}
                  </TableCell>
                  <TableCell
                    align={'left'}
                  >
                    {filiado.cpf}
                  </TableCell>
                  <TableCell
                    align={'left'}
                  >
                    {filiado.numeroCr}
                  </TableCell>
                  <TableCell
                    align={'left'}
                  >
                    {filiado.validadeAnuidade ? moment(new Date(filiado.validadeAnuidade)).format('DD/MM/YYYY') : 'Não informado'}
                  </TableCell>
                  <TableCell
                    align={'left'}
                  >
                    <Box
                      component={'div'}
                      display={'inline'}
                    >
                      {filiado.filiacaoStatus ? filiado.filiacaoStatus.descricao : 'Não informado'}
                    </Box>
                    {filiado.filiacaoStatus && filiado.filiacaoStatus.idFiliacaoStatus === Values.FiliacaoStatusValues.pendente &&
                    <Box
                      component={'div'}
                      display={'inline'}
                    >
                      <Tooltip title="Filiado com pré-inscrição. Necessário atenção.">
                        <IconButton
                          aria-label="update"
                          className={classes.margin}
                        >
                          <ReportProblemOutlinedIcon
                            fontSize={'small'}
                            style={{
                              paddingLeft: 5,
                              color: yellow[800]
                            }}
                          />
                        </IconButton>
                      </Tooltip>
                    </Box>
                    }
                    {filiado?.filiacaoStatus?.idFiliacaoStatus === Values.FiliacaoStatusValues.inadimplente &&
                    <Box
                      component={'div'}
                      display={'inline'}
                    >
                      <Tooltip title="Filiado inadimplente. Necessário atenção.">
                        <IconButton
                          aria-label="update"
                          className={classes.margin}
                        >
                          <HighlightOffIcon
                            fontSize={'small'}
                            style={{
                              paddingLeft: 5,
                              color: red[800]
                            }}
                          />
                        </IconButton>
                      </Tooltip>
                    </Box>
                    }

                  </TableCell>

                  <TableCell
                    align={'right'}
                    style={{width: '20%'}}
                  >
                    <Box
                      component={'div'}
                      display={'inline'}
                      visibility={'visible'}
                    >

                      <IconButton
                        aria-label="update"
                        className={classes.margin}
                        onClick={e => downloadPDF(index)}
                      >
                        <ArrowDownward
                          color = 'action'
                          fontSize='small'
                        />
                      </IconButton>

                      <IconButton
                        aria-label="update"
                        className={classes.margin}
                        onClick={e => editFiliado(index)}
                      >
                        <EditIcon
                          color = 'action'
                          fontSize='small'
                        />
                      </IconButton>
                    </Box>
                    <Box
                      component={'div'}
                      display={'inline'}
                      visibility={'visible'}
                    >
                      <IconButton
                        aria-label="delete"
                        className={classes.margin}
                        onClick={e => deleteFiliado(index)}
                      >
                        <DeleteIcon
                          color = 'action'
                          fontSize='small'
                        />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>

              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default FiliadoTable;
